import React from 'react';
import PropTypes from 'prop-types';

const ItemInfo = ({ item, displayImg, itemProperties, language }) => (
  <div>
    <h4
      className="returns-sidebar-item-title"
      style={{
        margin: '0 0 1rem',
        textAlign: 'center',
        fontWeight: 'bold',
      }}
      dangerouslySetInnerHTML={{ __html: item.itemName }}
      aria-level="1"
    />
    {item.itemProperties &&
      item.itemProperties.map((property, index) => {
        const propertyKey = property.key.replace(' ', '_');
        if (itemProperties.indexOf(propertyKey) > -1) {
          const languageKey = language[`returns.item.${propertyKey}`];
          return (
            <p
              className={`sidebar-item-detail-line sidebar-item-detail-line-${index} ${propertyKey}`}
              key={propertyKey}
              style={{
                margin: '0',
                textAlign: 'center',
              }}
            >
              {languageKey ? (
                <span>
                  <span className="property-name">{languageKey}:</span>{' '}
                  <span
                    className="property-value"
                    dangerouslySetInnerHTML={{ __html: property.value }}
                  />
                </span>
              ) : (
                <span>
                  <span className="property-name">{propertyKey}:</span>{' '}
                  <span
                    className="property-value"
                    dangerouslySetInnerHTML={{ __html: property.value }}
                  />
                </span>
              )}
            </p>
          );
        }

        return null;
      })}
    {displayImg && (
      <img
        style={{
          width: '100px',
          height: 'auto',
          paddingTop: '10px',
        }}
        src={item.product_image_url}
        alt=""
        onError={(event) => {
          event.target.src = '/r2/img/blindItemImage.svg';
        }}
      />
    )}
  </div>
);

export default ItemInfo;

ItemInfo.propTypes = {
  item: PropTypes.shape({
    itemProperties: PropTypes.array,
  }),
  displayImg: PropTypes.bool,
  itemProperties: PropTypes.array,
  language: PropTypes.object,
};

ItemInfo.defaultProps = {
  item: { itemProperties: [] },
  itemProperties: [],
  language: {},
  displayImg: '',
};
